import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-infos-contato-colab',
  templateUrl: './infos-contato-colab.component.html',
  styleUrls: ['./infos-contato-colab.component.scss']
})
export class InfosContatoColabReadComponent {
  @Input() infos: any;
}
